import styled from "styled-components";

export const UserAccountFindPageContentLayout = styled.div`
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;

  .btnWrap {
    display: grid;
    grid-template-rows: 1fr auto;
    height: 100vh;
  }

  .bodyContent {
    display: flex;
    flex-direction: column;
    gap: 36px;
  }

  .buttonBox {
    width: 100%;
    display: flex;
    flex-direction: row;
    grid-row: 2/3;

    .small {
      width: 40%;
    }
  }
`;

export const UserAccountFindContentHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px;
`;

export const ContentHeaderTop = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;

  p {
    font-size: 1.4rem;
    font-weight: 600;
    color: ${(props) => props.theme.colors.primary};
  }
`;

export const ContentHeaderTopStepBox = styled.div`
  width: auto;
  background: ${(props) => props.theme.colors.primary};
  border-radius: 6px;
  padding: 3px 9px;

  color: ${(props) => props.theme.colors.white};
  font-size: 1.3rem;
`;

export const ContentHeaderBottom = styled.p`
  font-size: 2rem;

  span {
    color: ${(props) => props.theme.colors.primary};
    font-weight: 700;
  }
`;

export const UserAccountFindContentBody = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 50px;

  label {
    font-size: 1.5rem;
  }
`;

export const InputLabelText = styled.label`
  position: absolute;
  top: calc(50% - 1.2rem);
  left: 14px;
  color: ${(props) => props.theme.colors.placeholderTxt};
  padding: 0 6px;
  letter-spacing: -0.08rem;
  transition: all 0.2s;
  font-weight: 600;

  &::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 4px;
    left: 0;
    top: 7px;
    background: ${(props) => props.theme.colors.white};
    z-index: -1;
  }
`;

export const InputBox = styled.div`
  position: relative;

  input {
    width: 100%;
    border: 1px solid ${(props) => props.theme.colors.inputBorder};
    border-radius: 6px;
    padding: 18px;
    outline: none;
    transition: all 0.3s;
    font-size: 1.6rem;

    &::-webkit-input-placeholder {
      color: #fff;
    }
    &:-moz-placeholder {
      color: #fff;
      opacity: 1;
    }
    &::-moz-placeholder {
      color: #fff;
      opacity: 1;
    }
    &:-ms-input-placeholder {
      color: #fff;
    }

    &:focus {
      border: 1px solid ${(props) => props.theme.colors.primary};

      & + ${InputLabelText} {
        top: -8px;
        left: 6px;
        font-size: 1.4rem;
        font-weight: 600;
        color: ${(props) => props.theme.colors.primary};
      }
    }
  }

  &:has(input:focus) {
    ${InputLabelText} {
      background: ${(props) => props.theme.colors.mainBg};
    }
  }

  &:has(input:not(:placeholder-shown)) {
    ${InputLabelText} {
      top: -8px;
      left: 6px;
      background: ${(props) => props.theme.colors.mainBg};
      font-size: 1.4rem;
    }
  }
`;
